module.exports = __webpack_public_path__ + "img/burger.49acb62d.svg";